import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all asset meter records
export const getAssetMeter = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-meter`);
    return response.data;
  } catch (error) {
    console.error("Error fetching asset-meter:", error.response?.data || error);
    throw error;
  }
};

export const getAssetMetersByAssetId = async (assetId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-meter`, {
      params: { assetId },
    });
    return response.data;
  } catch (error) {
    console.error(
      'Error fetching asset meters for asset:',
      error.response?.data || error,
    );
    throw error;
  }
};

export const getAssetMeterByAssetAndMeter = async (assetId, meterId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-meter/by-asset-and-meter`, {
      params: { assetId, meterId },
    });
    return response.data;
  } catch (error) {
    console.error(
      'Error fetching asset meter by asset and meter:',
      error.response?.data || error,
    );
    throw error;
  }
};

// GET a single asset meter record
export const getAssetMeterById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-meter/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching asset-meter:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new asset meter record
export const createAssetMeter = async (assetMeterData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/asset-meter`, assetMeterData);
    return response.data;
  } catch (error) {
    console.error("Error creating asset-meter:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing asset meter record
export const updateAssetMeter = async (id, assetMeterData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/asset-meter/${id}`, assetMeterData);
    return response.data;
  } catch (error) {
    console.error("Error updating asset-meter:", error.response?.data || error);
    throw error;
  }
};

// DELETE an asset meter record
export const deleteAssetMeter = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/asset-meter/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting asset-meter:", error.response?.data || error);
    throw error;
  }
};
